import LandingPage from "@/components/LandingPage";

const internal = [
  { label: "Motorsport-Videoproduktion", to: "/motorsport-videoproduktion" },
  { label: "Sport-Content", to: "/sport-content" },
  { label: "Eventfilm", to: "/eventfilm" },
  { label: "Videoproduktion Bochum", to: "/videoproduktion-bochum" },
  { label: "Alle Leistungen", to: "/leistungen" },
];

const VideoproduktionRuhrgebiet = () => (
  <LandingPage
    path="/videoproduktion-ruhrgebiet"
    metaTitle="Videoproduktion Ruhrgebiet | Filmagentur Bochum, Dortmund, Essen"
    metaDescription="Videoproduktion im Ruhrgebiet: Imagefilm, Eventfilm, Motorsport- & Sport-Content für Bochum, Dortmund, Essen & ganz NRW. Cinematic & planbar."
    eyebrow="Videoproduktion · Ruhrgebiet · NRW"
    h1={
      <>
        Videoproduktion <span className="text-gradient">im Ruhrgebiet</span>.
      </>
    }
    intro="Cinematic Videoproduktion für das gesamte Ruhrgebiet – Bochum, Dortmund, Essen, Duisburg, Gelsenkirchen & Umgebung. Spezialisiert auf Motorsport, Sport, Event & Content."
    serviceName="Videoproduktion Ruhrgebiet"
    serviceDescription="Cinematic Videoproduktion und Content-Produktion im gesamten Ruhrgebiet, mit Sitz in Bochum. Imagefilme, Eventfilme, Motorsport- und Sport-Content."
    areaServed={["Bochum", "Dortmund", "Essen", "Duisburg", "Gelsenkirchen", "Herne", "Mülheim", "Oberhausen", "Ruhrgebiet", "Nordrhein-Westfalen"]}
    bullets={[
      { title: "Eine Crew, das ganze Revier", text: "Von Duisburg bis Dortmund – wir bewegen uns im Ruhrgebiet wie zuhause. Kurze Wege, schnelle Reaktion." },
      { title: "Imagefilme für NRW-Unternehmen", text: "Vom Mittelstand bis zum Konzern – wir produzieren Imagefilme, die zeigen, wofür ihr steht." },
      { title: "Eventfilm im Pott", text: "Festivals, Firmenevents, Sportveranstaltungen – wir liefern den Aftermovie, der den Tag noch einmal erlebbar macht." },
      { title: "Motorsport & Sport", text: "Spezialisten für Motorsport- und Sport-Content. Vom Lokalverein bis zur internationalen Rennserie." },
      { title: "Lokale Marktkenntnis", text: "Wir kennen Locations, Genehmigungswege und Ansprechpartner im Ruhrgebiet – das spart Zeit & Budget." },
      { title: "Cinematic Look", text: "Kinoreife Bildsprache, präziser Ton, schneller Schnitt – ohne Stockfilm-Optik." },
    ]}
    faqs={[
      { q: "In welchen Städten im Ruhrgebiet seid ihr aktiv?", a: "In allen – Bochum, Dortmund, Essen, Duisburg, Gelsenkirchen, Herne, Mülheim, Oberhausen, Witten und Umgebung. Reisetage innerhalb des Ruhrgebiets stellen wir nicht zusätzlich in Rechnung." },
      { q: "Produziert ihr auch in ganz NRW oder bundesweit?", a: "Ja. Unser Schwerpunkt ist das Ruhrgebiet, wir drehen aber regelmäßig in ganz NRW und bundesweit." },
      { q: "Habt ihr Referenzen aus der Region?", a: "Ja. Auf Anfrage zeigen wir gerne Referenzen aus den jeweiligen Branchen und Städten." },
      { q: "Wie schnell bekommen wir ein Angebot?", a: "Nach einem kurzen Briefing-Call erstellen wir innerhalb von wenigen Werktagen ein transparentes Festpreis-Angebot." },
    ]}
    internalLinks={internal}
  />
);

export default VideoproduktionRuhrgebiet;
